import { ComponentsLayout } from '@components/ComponentsLayout'
import { Footer } from '@components/Footer'
import { ReminderBanner } from '@components/ReminderBanner'
import { useEffect } from 'react'

import { setFlowCompleted } from '@/api/actions'
import { useCheckBoxModal } from '@/hooks/useCheckBoxModal'
import { useLoading } from '@/hooks/useLoading'
import { useModule } from '@/hooks/useModule'
import { useReminder } from '@/hooks/useReminder'
import { useStep } from '@/hooks/useStep'
import { useUser } from '@/hooks/useUser'
import { ACTION_TYPE, OnLoadAction } from '@/types/action'

let currentModuleId: string | null = null

export const Step = () => {
  const { reminderSet } = useReminder()
  const { currentStep } = useStep()
  const { currentModule } = useModule()
  const { user } = useUser()
  const { loading, hideLoading } = useLoading()
  const { opened: checkBoxModalOpened, url: checkBoxModalUrl } = useCheckBoxModal()

  const moduleChanged = currentModule && currentModuleId !== currentModule.id

  const executeOnLoadActions = async (actions: OnLoadAction[]) => {
    if (!user?.data?.uniqueId) throw new Error('No user uniqueId found')

    for (const action of actions) {
      try {
        switch (action) {
          case ACTION_TYPE.SET_FLOW_COMPLETED:
            await setFlowCompleted({ uniqueId: user.data.uniqueId })
            break
        }
      } catch (e) {
        console.error(e)
      }
    }
  }

  const handleOnLoadActions = async () => {
    // First execute module actions (if module has changed - so first time module loads), then step actions (on each step change)

    if (moduleChanged && currentModule.onLoadActions) await executeOnLoadActions(currentModule.onLoadActions)
    if (currentStep?.onLoadActions) await executeOnLoadActions(currentStep.onLoadActions)
  }

  useEffect(() => {
    if (!currentStep || !currentModule) return

    if (currentModuleId !== null) handleOnLoadActions() // Don't execute on first time
    if (moduleChanged) currentModuleId = currentModule.id // Update current module id if module id has changed

    window.scrollTo(0, 0)
  }, [currentStep, currentModule])

  if (!currentStep || !currentModule) return null

  const { components, componentsOrder, id } = currentStep
  return (
    <>
      <div className="grow" id={id} data-testid="step-container">
        {checkBoxModalOpened ? (
          <iframe
            data-testid="checkbox-modal-iframe"
            className="absolute top-0 left-0 h-full w-full"
            src={checkBoxModalUrl}
            onLoad={() => {
              hideLoading()
            }}
          />
        ) : (
          <>
            {reminderSet && !loading && <ReminderBanner />}

            <div className="flex flex-col p-6">
              <ComponentsLayout components={components} componentsOrder={componentsOrder} />
            </div>
          </>
        )}
      </div>

      {currentStep?.showFooter && <Footer />}
    </>
  )
}
